import './Loading.css'

function Loading() {
  return <div className="spinner" />
}

export default Loading
